var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.unSubscribeTmpIds.length >0)?_c('WxSubscribe',{ref:"wxSubscribeBtn",attrs:{"templateIds":_vm.unSubscribeTmpIds},on:{"success":_vm.onSuccess,"fail":_vm.onFail}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }